/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


document.addEventListener('DOMContentLoaded', function() {
  // Znajdź wszystkie <p> wewnątrz .collection__description .rte
  var paragraphs = document.querySelectorAll('.collection__description .rte p');
  
  paragraphs.forEach(function(p) {
    // Filtrujemy wyłącznie te <p>, które mają dokładnie JEDEN węzeł potomny ELEMENTOWY
    // i ten element to <strong>
    //  – p.childElementCount – liczba POTOMNYCH węzłów typu "Element"
    //  – p.firstElementChild.tagName – nazwa tego elementu (będzie 'STRONG', jeśli to <strong>)
    if (p.childElementCount === 1
        && p.firstElementChild.tagName.toLowerCase() === 'strong'
        // Dodatkowo upewniamy się, że nie ma żadnego tekstu przed/po <strong>
        // czyli p.childNodes.length == liczba wszystkich węzłów, wliczając teksty
        && p.childNodes.length === 1
    ) {
      // Nadamy temu <strong> klasę 'solo-strong'
      p.firstElementChild.classList.add('solo-strong');
    }
  });
});

function ensureNettoSuffix(root) {
  var scope = root && root.querySelectorAll ? root : document;
  var priceLists = scope.querySelectorAll('.product_price_box .price-list, .product-form .price-list');

  priceLists.forEach(function(priceList) {
    // If the markup already contains "netto" (from Liquid), don't add another one
    if (/\bnetto\b/i.test(priceList.textContent || '')) return;

    var priceEl = priceList.querySelector('.price');
    if (!priceEl) return;

    // Avoid duplicating suffix
    if (priceEl.querySelector('.price-netto-suffix')) return;

    var suffix = document.createElement('span');
    suffix.className = 'price-netto-suffix';
    suffix.textContent = '\u00A0netto';

    priceEl.appendChild(suffix);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  ensureNettoSuffix(document);
});

document.addEventListener('variant:changed', function(event) {
  // theme.js updates `.price-list` on variant change, so re-append netto suffix after update
  ensureNettoSuffix(event && event.target ? event.target : document);
});

/* LeaseLink: hook .gift-offer-block + pokaż kafelek tylko gdy wtyczka doda #installment-price */
(function () {
  function findActiveBanner() {
    return document.querySelector('.product-calculator .ts-raty-static')
      || document.querySelector('.product-form__buy-buttons .ts-raty-static')
      || document.querySelector('.ts-raty-static');
  }

  function findVisibleAddButton() {
    var btns = document.querySelectorAll(
      '.product-form__add-button[data-action="add-to-cart"], .product-form__payment-container > button'
    );
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].offsetWidth || btns[i].offsetHeight) return btns[i];
    }
    return null;
  }

  function bannerHasOffer(wrap) {
    return !!(wrap && wrap.querySelector('#installment-price'));
  }

  function syncLeasingVisibility() {
    document.querySelectorAll('.ts-raty-static').forEach(function (wrap) {
      wrap.style.display = bannerHasOffer(wrap) ? '' : 'none';
    });
  }

  function hideLeasingBanners() {
    document.querySelectorAll('.ts-raty-static').forEach(function (wrap) {
      wrap.style.display = 'none';
    });
  }

  function watchLeasingOffer() {
    syncLeasingVisibility();
    [600, 1200, 2000, 3500, 5000, 8000].forEach(function (t) {
      setTimeout(syncLeasingVisibility, t);
    });
  }

  function bindLeasingObserver() {
    var target = document.querySelector('.gift-offer-block .gift-payment-info.product-page');
    if (!target) return;
    if (window.__tsLeasingObserver) window.__tsLeasingObserver.disconnect();
    window.__tsLeasingObserver = new MutationObserver(syncLeasingVisibility);
    window.__tsLeasingObserver.observe(target, { childList: true, subtree: true, characterData: true });
  }

  function bindLeasingQuantityWatch() {
    var qty = document.getElementById('product-quantity');
    if (!qty || qty.dataset.leasingWatch) return;
    qty.dataset.leasingWatch = '1';
    qty.addEventListener('input', function () {
      hideLeasingBanners();
      watchLeasingOffer();
    });
  }

  function ensureLeasingBanner() {
    document.querySelectorAll('.ts-raty-static').forEach(function (b) {
      b.classList.remove('gift-offer-block');
    });

    var active = findActiveBanner();
    if (!active) {
      var btn = findVisibleAddButton();
      if (btn && btn.parentNode) {
        active = document.createElement('div');
        active.className = 'ts-raty-static';
        active.style.cssText = 'margin:10px 0;overflow:visible;background:transparent;display:none;';
        active.innerHTML =
          '<div class="gift-payment-info product-page">Raty / Odroczona płatność / Leasing dla firm</div>';
        btn.parentNode.insertBefore(active, btn);
      }
    }

    if (active) active.classList.add('gift-offer-block');
    bindLeasingObserver();
  }

  function runLeasingBannerFix() {
    try {
      ensureLeasingBanner();
      bindLeasingQuantityWatch();
      watchLeasingOffer();
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runLeasingBannerFix);
  } else {
    runLeasingBannerFix();
  }
  [150, 400, 800, 1500, 3000].forEach(function (t) { setTimeout(runLeasingBannerFix, t); });
  document.addEventListener('variant:changed', function () {
    hideLeasingBanners();
    runLeasingBannerFix();
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.quantity-selector__button')) {
      hideLeasingBanners();
      setTimeout(runLeasingBannerFix, 1200);
    }
  });
})();
